module.exports = __webpack_public_path__ + "img/marker_four_blue1.6e4062a6.png";